import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    mode: { type: String, default: "example" },
    pasteText: { type: String, default: "" },
    exampleText: { type: String, default: "" },
    pasteHint: String,
    scenarioText: String,
  }

  static targets = ["textarea", "scenarioBox", "helper", "pasteBtn", "exampleBtn"]

  connect() {
    this.render()
    // Seed listeners (drill controller) on connect so auto-populate can fire.
    this.emit()
  }

  setMode(event) {
    const next = event.params.mode
    if (next === this.modeValue) return
    this.persistCurrent()
    this.modeValue = next
    this.render()
    this.emit()
  }

  input() {
    this.persistCurrent()
    this.renderHelper()
    this.emit()
  }

  persistCurrent() {
    if (this.modeValue === "paste") this.pasteTextValue = this.textareaTarget.value
    else this.exampleTextValue = this.textareaTarget.value
  }

  render() {
    const isExample = this.modeValue === "example"
    this.textareaTarget.value = isExample ? this.exampleTextValue : this.pasteTextValue
    this.textareaTarget.placeholder = isExample ? "" : (this.pasteHintValue || "Paste your content here…")
    if (this.hasScenarioBoxTarget) this.scenarioBoxTarget.hidden = !isExample
    if (this.hasPasteBtnTarget) this.pasteBtnTarget.classList.toggle("source-picker-tab--active", !isExample)
    if (this.hasExampleBtnTarget) this.exampleBtnTarget.classList.toggle("source-picker-tab--active", isExample)
    this.renderHelper()
  }

  renderHelper() {
    if (!this.hasHelperTarget) return
    const isPaste = this.modeValue === "paste"
    const text = this.textareaTarget.value
    let msg
    if (isPaste) {
      const trimmed = text.trim()
      const wc = trimmed.length === 0 ? 0 : trimmed.split(/\s+/).filter(Boolean).length
      msg = wc === 0
        ? "Tip: shorter is better — even one paragraph is enough"
        : `${wc} words pasted`
    } else {
      msg = "Edit the example to match your context — it's yours now"
    }
    this.helperTarget.textContent = msg
  }

  emit() {
    this.dispatch("change", {
      detail: { text: this.textareaTarget.value, mode: this.modeValue },
    })
  }
}
